import _isNil from "lodash/isNil";
import { useEffect } from 'react';
const MARGIN_TO_REMOVE = 20;
export default (isDropAnimating, itemRef, itemOffset) => {
  useEffect(() => {
    if (isDropAnimating) {
      const droppableArea = document.querySelector('.droppable-area.is-dragging-over');
      if (!_isNil(droppableArea) && !_isNil(itemRef.current) && !droppableArea.contains(itemRef.current) && itemOffset === 0) {
        Object.assign(itemRef.current.style, {
          width: "".concat(droppableArea.getBoundingClientRect().width - MARGIN_TO_REMOVE, "px")
        });
      }
    }
  }, [isDropAnimating, itemRef, itemOffset]);
};